import React from 'react';
import {
  Modal,
  Button,
  FormButton,
  Text,
} from '@cochlear-design-system/foundation';

const AssignLoanerConfirmationModal = ({
  labels,
  onSubmit,
  onClose,
  visible,
  isSubmitting = false,
}) => (
  <Modal
    dialogClassName="assign-loaner-confirmation-modal"
    size="lg"
    show={visible}
  >
    <Modal.Header
      closeButton
      onHide={onClose}
      data-analytics="cancel_header_assign_loaner_confirmation"
    >
      <Modal.Title>
        {labels['labels.assignLoanerDetails.header.title']}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Text
        content={
          labels['labels.assignLoanerDetails.confirmation.message']
        }
      />
    </Modal.Body>
    <Modal.Footer>
      <FormButton
        onClick={onSubmit}
        text={labels['labels.common.confirm']}
        progress={isSubmitting ? 2 : undefined}
        disabled={isSubmitting}
        type="save"
        data-analytics="confirm_assign_loaner_confirmation"
      />
      <Button
        variant="tertiary"
        onClick={onClose}
        text={labels['labels.common.cancel']}
        disabled={isSubmitting}
        data-analytics="cancel_assign_loaner_confirmation"
      />
    </Modal.Footer>
  </Modal>
);

export default AssignLoanerConfirmationModal;
